import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHelp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM11.984 20H12C16.4167 19.9956 19.9942 16.4127 19.992 11.996C19.9898 7.57931 16.4087 4.00002 11.992 4.00002C7.57528 4.00002 3.99421 7.57931 3.992 11.996C3.98979 16.4127 7.56729 19.9956 11.984 20ZM13 18H11V16H13V18ZM13 15H11C10.9684 13.6977 11.6461 12.4808 12.77 11.822C13.43 11.316 14 10.88 14 10C14 8.89545 13.1046 8.00002 12 8.00002C10.8954 8.00002 10 8.89545 10 10H8V9.91002C8.01608 8.48096 8.79333 7.16902 10.039 6.46842C11.2846 5.76781 12.8094 5.78496 14.039 6.51342C15.2685 7.24187 16.0161 8.57096 16 10C15.9284 11.079 15.3497 12.0603 14.44 12.645C13.6177 13.1612 13.0847 14.0328 13 15Z",
		fill: "#525666"
	})
});
export default SvgHelp;
